import React, { useState, useEffect } from "react";
import { HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";
import { API_URL, getBaseUrl } from "../../../constants/api";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { pure } from "recompose";
import LogoIconNew from "../../../public/img/common/favicon.png";

import { getNotificationMasterData } from "../../../store/layout/actions";
import { useHistory } from "react-router-dom";
import { getCommunicationNotificationData, NOTIFICATION_TYPE } from "../../../utils/helper";
import { routes } from "../../../constants/routes";
import ConfirmDialog from "../Dailogbox/ConfirmDailog";
import store from "../../../store/appStore";
import * as actionType  from "../../../store/layout/actionTypes";
import { apiPutAsync, apiRequestAsync } from "../../../utils/api_service";
 
/**
 * Datacenter Notification Handler for SignalR connection
 * @param {*} props 
 * @returns 
 */
function DatacenterNotification(props) {
  const [connection, setConnection] = useState(null);
  const [data, setData] = useState({});
  const history = useHistory();
  
  /** call on onclick */
  const onClickHandel = (isValid) => {
    if (isValid) {
      navigateToRecord(data)
    }
    setData({});
   
  }

  /** Navigation */
  const navigateToRecord = async ({ item, action, type }) => {
    if (item.notificationType == NOTIFICATION_TYPE.Communication && action === "show") {
    const data= await getCommunicationNotificationData(item,type)
      history.push({
        pathname: routes.communication,
        notificationProps: {
          isOpenCommunication: true,
          isViewOnly: true,
          isReply: type === "reply",
          content: data.content ,
          mainContent: data.mainContent ,
          recordId: item.recordId
        },
      });
    }
    else if (item.notificationType == NOTIFICATION_TYPE.Request && action === "show") {

      history.push({
        pathname: routes.requests,
        notificationProps: {
          isOpenRequest: true,
          isViewOnly: true,
          isReply: type === "reply",
          recordId: item.recordId
        },
      });


    }
    else if (item.notificationType == NOTIFICATION_TYPE.SecurityIncident && action === "show") {
      history.push({
        pathname: routes.securityIncident,
        notificationProps: {
          isOpenRequest: true,
          isViewOnly: true,
          isReply: type === "reply",
          recordId: item.recordId
        },
      });
    }
    UpdateNotification(item.notificationId,"read",false);
  }

  /** Update notifcation functionality */
  function UpdateNotification(notificationId, type, all = false) {
    apiPutAsync({
      url: `${API_URL.Notification.Put}?id=${notificationId}&all=${all}&type=${type}`,
    }).then(({ data: response }) => {
      if (response.success !== true) {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
    dispatchEvent(getNotificationMasterData())
  }
  /**
   * Using Effect for keeping Connection Alive
   */
  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${getBaseUrl().replace("api", "")}servernotification`, HttpTransportType.LongPolling)
      .withAutomaticReconnect()
      .build();
    setConnection(newConnection);
  }, []);

  /**
   * Using Effect for generating notification message when signalr message is received
   */
  useEffect(() => {
    let userName = "";
    if (props !== undefined && props !== null) {
      if (props.userData !== null && props.userData !== undefined) {
        userName = props.userData.email;
      }
    }

    // console.log(groupName);
    if (connection) {
      // if (!('Notification' in window)) {
      //   // console.log('This browser does not support desktop notification');
      // } else {
      //   Notification.requestPermission();
      // }
      connection.start()
        .then(() => {
          connection.on("ReceiveMessage", message => {
            //console.log(message);
            const showWindowsNotification = false;
            if ((userName === message.intendedFor && userName !== message.createdBy)) {
              // ShowNotification(message, false, handelClick);
              //getNotificationMasterData();
              apiRequestAsync({
                url: API_URL.Notification.List,
                key: "pendingNotifications"
              }).then((pendingNotifications) => {
                let sorted=[];
                if(pendingNotifications.success){
                 sorted = pendingNotifications?.data?.sort((a, b) => {
                  const aDate = new Date(a.createdOn);
                  const bDate = new Date(b.createdOn);
                  return bDate.getTime() - aDate.getTime();
                });}
                store.dispatch({
                  type: actionType.GET_NOTIFICATION_DATA,
                  payload: sorted
                });
              });
              if (showWindowsNotification) {
                const notificationText = message.message;
                const notify = new Notification(message.tittle, {
                  icon: window.location.origin + "/" + LogoIconNew,
                  body: notificationText// message.notification,
                });
                notify.onclick = function (event) {
                  event.preventDefault();
                  window.open(window.location.origin + "/pendingRequests", "_self");
                };
              }
            }
          });
        })
        .catch(e => console.log("Connection failed: ", e));
    }
  }, [connection]);
  return (
    <div>
{data.showWarningMessage && (
                <ConfirmDialog
                    IsOpen={data.showWarningMessage}
                    Message={window.location.href.indexOf("communication") > 0
                        ?<><p>{"Are you sure you want to leave this page without sending your Communication?"}</p></>
                          : window.location.href.indexOf("request")>0 
                           ?<><p>{"Are you sure you want to leave this page without submitting your changes?"}</p></>
                           :<><p>{"Are you sure you want to leave this page without submitting your changes?"}</p></>}
                    OnHandelClick={(isValid) => {
                        if (isValid) {
                            onClickHandel(isValid);
                        } else {
                            onClickHandel(isValid);
                        }
                    }}
                    AgreeText={"Yes"}
                    DisAgreeText={"No"}
                />
            )}
    </div>
  );
}

export default pure(DatacenterNotification);
